export default{
    en:{
        modalTitle: '평가시행세칙 업로드'
    },
    ko:{
        modalTitle: '평가시행세칙 업로드'
    }
}